export const parsePlan = (user: IUser) => {
  const { planId = '', planName } = user;

  if (planId === 'visitor') {
    return user;
  }

  const output = {
    planId: 'free',
    planName: 'Starter',
    isPayingUser: false,
  };

  if (planId.startsWith('pro')) {
    output.planId = 'popular';
    output.planName = 'Plus';
    output.isPayingUser = true;
  }

  return output;
};
